import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getMinistries = () => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.MINISTRIES_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getMinistries"
    })
      .then((response) => {
        dispatch({
          type: actions.MINISTRIES_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_MINISTRIES_DETAILS,
          payload: {
            data: response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.MINISTRIES_HTTP_ERROR, error, dispatch);
      });
  };
};
